export default __webpack_public_path__ + "static/media/09.5f059f52.jpg";